import React from 'react';
import { ErrorMessage } from "formik";
import PropTypes from 'prop-types';

import s from '../Cliente/contacto.module.scss'

/**
 *
 * @param field
 * @param form
 * @param label
 * @param type
 * @returns {*}
 * @constructor
 */

// const TextComponent = ({ field, label, type, placeholder, onChange, error = false }) => {

const TextComponent = ({
   field, // { name, value, onChange, onBlur }
   form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
   ...props
}) => {

    const error = touched && errors[field.name]

    let className = props.className ?? ''

    if (error)
        className = 'is-invalid'

    return (
        <div className={s.formGroup}>
            <input
                placeholder={props.label && props.label}
                {...props}
                className={`${s.formControl} ${className}`}
                {...field}
            />
            <ErrorMessage name={field.name} className={s.errorField} component="div" />
        </div>
    )
}


TextComponent.propTypes = {
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
}

export default TextComponent;
